import { Injectable } from '@angular/core';
import { ApiService } from './Api.service';

@Injectable({
  providedIn: 'root'
})
export class BlogService {

  postUrl = 'public/post/';
  postUrlSlug = 'public/post-slug/';
  postUrlRel = 'public/post-rel/';
  baseDataUrl = 'data';
  lessonStatusUrl = 'lesson_status';
  postListUrl = 'public/list/post';
  contactUrl = 'contact';
  subscribeUrl = 'subscription';
  reviewUrl = 'review';
  finishedCoursesUrl = 'public/list/finished';

  constructor(private apiService: ApiService) {
  }



  async getPublicList(page = 1,filter='') {
    try {
      if (filter=='Todos'){
        filter='';
      }else{
        filter='&tags='+filter
      }
      const posts = await this.apiService.get(this.postListUrl.concat('?page=' + page +filter));
      return posts;
    } catch (error) {
      return error;
    }
  }
  async getPublicRelationPost(id) {
    try {
      console.log(id);
      const posts = await this.apiService.get(this.postUrlRel.concat(id));
      return posts;
    } catch (error) {
      return error;
    }
  }

  async getPublicPost(postId) {
    try {
      const post = await this.apiService.get(this.postUrl.concat(postId));
      return post;
    } catch (error) {
      return error;
    }
  }
 
  async getPublicPostBySlug(slug) {
    try {
      const post = await this.apiService.get(this.postUrlSlug.concat(slug));
      return post;
    } catch (error) {
      return error;
    }
  }

}
